import { render, staticRenderFns } from "./loading.component.vue?vue&type=template&id=66eb2c20"
import script from "./loading.component.vue?vue&type=script&lang=js"
export * from "./loading.component.vue?vue&type=script&lang=js"
import style0 from "./loading.component.vue?vue&type=style&index=0&id=66eb2c20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports